var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getConfig, getLocale, } from "@jti/fe-common";
import { getUser } from "../../utils";
import { CasBaseApi } from "./CasBaseApi";
export class CasPurposesApi extends CasBaseApi {
    constructor(baseUrl, tenantToken, ciamToken, userUuid, lang) {
        super(baseUrl, tenantToken, ciamToken);
        this.tenantToken = tenantToken;
        this.ciamToken = ciamToken;
        this.userUuid = userUuid;
        this.lang = lang;
        this.name = "CasPurposesApi";
    }
    static init() {
        const config = getConfig();
        const user = getUser();
        const locale = getLocale();
        return new CasPurposesApi(config.CAS_URL, config.CAS_X_DES_AK_TENANT_TOKEN, user.ciam_token, user.uuid || "", locale);
    }
    preparePurposesFromEvo(purposes, contextName) {
        return purposes.map((_a) => {
            var { context } = _a, legacyObject = __rest(_a, ["context"]);
            return (Object.assign(Object.assign({}, legacyObject), { [contextName]: context }));
        });
    }
    getPurposesByStep(step) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isEvo) {
                const uri = `/consents?language=${this.lang}&context=${step}`;
                const { data } = yield this.request(uri, {}, true, true);
                return this.preparePurposesFromEvo(data, "step");
            }
            const uri = `/purposes?language=${this.lang}&step=${step}`;
            const { data } = yield this.request(uri, {}, true, true);
            return data;
        });
    }
    getPurposesByCategory(category) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isEvo) {
                const uri = `/consents?language=${this.lang}&context=${category}`;
                const { data } = yield this.request(uri, {}, true, true);
                return this.preparePurposesFromEvo(data, "category");
            }
            const uri = `/purposes?language=${this.lang}&category=${category}`;
            const { data } = yield this.request(uri, {}, true, true);
            return data;
        });
    }
    getPurposesForUserByStep(step_1) {
        return __awaiter(this, arguments, void 0, function* (step, isCached = true) {
            if (this.isEvo) {
                const uri = `/users/${this.userUuid}/consents?language=${this.lang}&context=${step}`;
                const { data } = yield this.request(uri, {}, true, isCached);
                return this.preparePurposesFromEvo(data, "step");
            }
            const uri = `/purposes/${this.userUuid}?language=${this.lang}&step=${step}`;
            const { data } = yield this.request(uri, {}, true, isCached);
            return data;
        });
    }
    updateUserConsentsEvo(consentPayload_1) {
        return __awaiter(this, arguments, void 0, function* (consentPayload, isCached = false) {
            const uri = `/users/${this.userUuid}/consents`;
            return yield this.request(uri, {
                body: JSON.stringify(consentPayload),
                method: "PATCH",
            }, true, isCached);
        });
    }
    getPurposesForUserByCategory(category, isCached) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isEvo) {
                const uri = `/users/${this.userUuid}/consents?language=${this.lang}&context=${category}`;
                const { data } = yield this.request(uri, {}, true, isCached);
                return this.preparePurposesFromEvo(data, "category");
            }
            const uri = `/purposes/${this.userUuid}?language=${this.lang}&category=${category}`;
            const { data } = yield this.request(uri, {}, true, isCached);
            return data;
        });
    }
}
//# sourceMappingURL=CasPurposesApi.js.map